(()=>{
 if(window.c24BirdHoverLoaded)return;window.c24BirdHoverLoaded=true;
 const desktop=matchMedia('(min-width:769px) and (hover:hover) and (pointer:fine)');
 function mount(scope){scope.querySelectorAll('[data-c24-bird]').forEach(link=>{
  if(link.dataset.c24BirdMounted)return;link.dataset.c24BirdMounted='true';
  let intent,end,played=false;
  function enter(){if(!desktop.matches||played)return;clearTimeout(intent);intent=setTimeout(()=>{if(!desktop.matches||!link.isConnected)return;played=true;link.classList.add('c24-bird-playing');clearTimeout(end);end=setTimeout(()=>link.classList.remove('c24-bird-playing'),1500)},350)}
  function leave(){clearTimeout(intent);played=false}
  link.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')enter()});
  link.addEventListener('pointerleave',leave);
  link.addEventListener('focus',()=>{if(link.matches(':focus-visible'))enter()});
  link.addEventListener('blur',leave);
 });}
 mount(document);document.addEventListener('shopify:section:load',e=>mount(e.target));
})();
